require('angularjs-toast/angularjs-toast');

module.exports = 'angularjsToast';